import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import '../App.css';

import '../config.js';

const restServer = global.restServer;

class Download extends Component {
    constructor(props) {
        super(props);
        this.state = {results: null, stats:{}};
    }

    componentDidMount() {
        const url = [restServer, 'stats'].join("/");
        fetch(url)
        .then(response => response.json())
        .then(data => this.setState({stats: data}));
    }

    render() {
        let release_date = "2021-04-23";
        let covid_domains = "47";
        let covid_structures = "11,329";
        let libraries = {
            'representative': [
                { name: "scop_fa_represeq_lib_latest.fa", description: "scop family representative domain sequences"},
                {name: "scop_sf_represeq_lib_latest.fa", description: "scop superfamily representative domain sequences"}
            ],
            'clustering':[
                { name: "scop_fa_represeq_lib_latest.40clust", description: ""},
                { name: "scop_fa_represeq_lib_latest.95clust", description: ""},
                { name: "scop_sf_represeq_lib_latest.40clust", description: ""},
                { name: "scop_sf_represeq_lib_latest.95clust", description: ""}
            ]
        }

        if (this.state.stats) {
            const rest_stats = this.state.stats.stats || {};
            covid_domains = rest_stats.covid_domains || covid_domains;
            covid_structures = rest_stats.covid_structures || covid_structures; 
            release_date = rest_stats.release_date || release_date;
          
            const libs = this.state.stats.libraries || {};
            for (var key of Object.keys(libs)) {
                // representative.scop_sf_represeq_lib20210330.fa : scop superfamily representative domain sequence 
                const lib_desc = key.split('.');
                const ltype = lib_desc.shift();
                libraries[ltype].push({'name': lib_desc.join('.'), 'description': libs[key]})
                //console.log(lib_desc + " -> " + libs[key])
            }
        }

        //console.log(libraries);
        return (
            <div className="page-content">
                <div className="page-title">SCOP2 Downloads</div>
                <div className="page-section">
                    <p>
                        Distributable files of the SCOP database - release {release_date}. Other file formats can be provided upon user request. 
                    </p> 
                    <p>
                        SARS-CoV-2 SCOP2 domain classification is available here: <a href={`${process.env.PUBLIC_URL}/files/scop-cla-SARS-CoV-2.txt`}>scop-cla-SARS-CoV-2.txt</a>
                    </p>
                    <div className="help-section">1. SCOP parseble files</div>
                    SCOP domain definitions and classification.
                    <p>
                        File: <a href={`${process.env.PUBLIC_URL}/files/scop-cla-latest.txt`}>scop-cla-latest.txt</a>
                    </p>
                    <p>
                        Fields are as follows:
                    </p>
<p>
FA-DOMID - SCOP representative family domain identifier<br/>
FA-PDBID - representative PDB identifier<br/>
FA-PDBREG - family domain region in PDB resudue numbering <br/>
FA-UNIID - representative UniProt accession number<br/>
FA-UNIREG - family domain region in the Uniprot sequence<br/>
SF-DOMID - SCOP representative superfamily domain identifier<br/>
SF-PDBID - representative PDB identifier<br/>
SF-PDBREG - superfamily domain region in PDB resudue numbering<br/>
SF-UNIID - representative UniProt accession number<br/>
SF-UNIREG - superfamily domain region in the Uniprot sequence<br/>
SCOPCLA - SCOP domain classification. The abbreviations denote: TP=protein type, CL=protein class, CF=fold, SF=superfamily, FA=family<br/> 
</p>
SCOP node descriptions.
<p>
File: <a href={`${process.env.PUBLIC_URL}/files/scop-des-latest.txt`}>scop-des-latest.txt</a>
</p><p>
Fields are as follows:
</p>
<p>
NODE_ID - SCOP node identifier<br/>
NODE_NAME - SCOP node name<br/>
</p>
SCOP represented structures.
<p>
File: <a href={`${process.env.PUBLIC_URL}/files/scop-represented-structures-latest.txt`}>scop-represented-structures-latest.txt</a>
</p><p>
Fields are as follows:
</p>
<p>
DOMID - SCOP representative domain identifier<br/>
REPRESENTED_PDBID - represented structure PDB identifier<br/>
REPRESENTED_PDBCHAIN - represented structure chain identifier<br/>
</p> 

<div className="help-section">
2. SCOP sequence libraries
</div>
<p>

The SCOP domain sequences are derived from the UniProtKB sequence. The files are in fasta format and contain:
</p>
        {
          libraries['representative'].map( (item) => (
            <p key={item.name}>
                File: <a href={`${process.env.PUBLIC_URL}/files/` + item.name}>{item.name}</a>  {item.description}
            </p>              
          ))
        }
<p>
Results of clustering SCOP domain sequences at 95% and 40% sequence identity.
</p>
        {
          libraries['clustering'].map( (item) => (
            <p key={item.name}>
                File: <a href={`${process.env.PUBLIC_URL}/files/` + item.name}>{item.name}</a>  {item.description}
            </p>              
          ))
        }


<div className="help-section">3. Additional SCOP data</div>
<p>
The SCOP classification expanded to the represented structures (namely SCOP2B) and residue-level cross-reference between PDB and UniProtKB entries for SCOP domains are available from European Bioinformatics Institute FTP site that provides access to data from <a href="ftp://ftp.ebi.ac.uk/pub/databases/msd/sifts/">SIFTS</a>.
</p>
<p>The SCOP expanded data is available in both a tab-delimited ASCII format (TSV) and a comma-separated value format (CSV). The residue-level cross-reference data is available in XML format for each PDB entry that has been classified in SCOP.
</p>

<div className="notes">
Notes:
</div>
Examples of SCOP classification desribed in <a href="https://doi.org/10.1093/nar/gkz1064">here</a>

<div className="example-section">
    <div className="example-title">
      1. Family and superfamily domains having different domain boundaries
    </div>
    <div className="example-parseable">
      8002798 1SFX A:1-106 O28271 1-106 8002799 1SFX A:17-80 O28271 17-80 TP=1,CL=1000003,CF=2000144,SF=3000034,FA=4000158
    </div>
</div>

<div className="example-section">
    <div className="example-title">
      2. Multidomain family domain that spans two superfamily domains
    </div>
    <div className="example-parseable">
      <div>8045656 3GD0 A:37-401 Q9Z4I2 37-401 8091286 3GD0 A:37-243,A:353-401 Q9Z4I2 37-243,353-401 TP=1,CL=1000001,CF=2000893,SF=3001451,FA=4004596</div>
      <div>8045656 3GD0 A:37-401 Q9Z4I2 37-401 8091287 3GD0 A:244-352 Q9Z4I2 244-352 TP=1,CL=1000003,CF=2001450,SF=3002495,FA=4004596</div>
    </div>
</div>

<div className="example-section">
    <div className="example-title">
      3. SCOP domain that belongs to family that evolved different fold than the cannonical superfamily fold
    </div>
    <div className="example-parseable">
      8090250 5V1V A:1-86 D1CIZ5 1-86 8090249 5V1V A:1-86 D1CIZ5 1-86 TP=1,CL=1000003,CF=2001452,SF=3000034,FA=4005476
    </div>
</div>

<div className="example-section">
    <div className="example-title">
      4. SCOP domain member of the same superfamily as in 3. but having a cannonical fold
    </div>
    <div className="example-parseable">
      8002595 1JHF A:2-72 P0A7C2 2-72 8002596 1JHF A:2-72 P0A7C2 2-72 TP=1,CL=1000003,CF=2000144,SF=3000034,FA=4000150
    </div>
</div>


                </div>
            </div>
        );
    }   
}

export default withRouter(Download);
